// A utility function to work with table selection operations
// While enabling table edit mode, an instance of this is created
// and it is deleted on quitting table edit mode
export default class TableSelection {
  constructor (tableElement) {
    this.tableElement = tableElement;
    this.numberOfSelectedCells = 0;
  }

  // Gets an array of g.table-cell that are currently selected
  getSelectedCellElements () {
    const rects = this.tableElement.querySelectorAll('rect.table-cell-selected');
    // 1st parentElement is g.textarea
    // 2nd parentElement is g.table-cell
    return [...rects].map(rect => rect.parentElement.parentElement);
  }

  toggleTableSelectorBorder () {
    const selector = INKIVE.EditorFacade.editor.canvas.selectorManager.findSelectorByElement(this.tableElement);
    selector?.toggleSelectorRect(this.numberOfSelectedCells <= 1);
  }

  select (cells) {
    const cellRectElements = Array.from(cells).map(cell => cell.querySelector('rect'));

    cellRectElements.forEach(cellRectElement => {
      cellRectElement.classList.contains('table-cell-selected') || cellRectElement.classList.add('table-cell-selected');
    });

    this.numberOfSelectedCells += cellRectElements.length;
    this.toggleTableSelectorBorder();
    INKIVE.Menus.elementPopupMenu.refresh();
    INKIVE.EditorFacade.trigger('table.selection_changed');
  }

  unselect (cells) {
    const cellRectElements = Array.from(cells).map(cell => cell.querySelector('rect'));

    cellRectElements.forEach(cellRectElement => {
      cellRectElement.classList.remove('table-cell-selected');
    });

    this.numberOfSelectedCells -= cellRectElements.length;
    this.toggleTableSelectorBorder();
    INKIVE.Menus.elementPopupMenu.refresh();
    INKIVE.EditorFacade.trigger('table.selection_changed');
  }

  // Gets an array of all g.table-cell
  getAllCellElements () {
    const cells = [...this.tableElement.querySelectorAll('g.table-cell')];

    return cells;
  }

  // Select all cells from the current table
  selectAll () {
    const cellRectElements = this.tableElement.querySelectorAll('g.table-cell rect');

    cellRectElements.forEach(cellRectElement => {
      cellRectElement.classList.contains('table-cell-selected') || cellRectElement.classList.add('table-cell-selected');
    });

    this.numberOfSelectedCells += cellRectElements.length;
    this.toggleTableSelectorBorder();
    INKIVE.Menus.elementPopupMenu.refresh();
    INKIVE.EditorFacade.trigger('table.selection_changed');
  }

  // Invert selection
  invertSelection () {
    const cellRectElements = this.tableElement.querySelectorAll('g.table-cell rect');

    cellRectElements.forEach(cellRectElement => {
      cellRectElement.classList.contains('table-cell-selected')
        ? cellRectElement.classList.remove('table-cell-selected')
        : cellRectElement.classList.add('table-cell-selected');
      this.numberOfSelectedCells += cellRectElement.classList.contains('table-cell-selected')
        ? 1
        : -1;
    });

    this.toggleTableSelectorBorder();
    INKIVE.Menus.elementPopupMenu.refresh();
    INKIVE.EditorFacade.trigger('table.selection_changed');
  }

  // Clear current selection
  clear () {
    const cellRectElements = this.tableElement.querySelectorAll('rect.table-cell-selected');
    this.numberOfSelectedCells = 0;
    this.toggleTableSelectorBorder();

    cellRectElements.forEach(cellRectElement => cellRectElement.classList.remove('table-cell-selected'));
  }
}
